export const blockIconsAudioandvideoPauseCircle = (
	<span className='material-symbols-outlined'>pause_circle</span>
);
